export default [
    {
        field: 'max_afp_uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo AFP ($)',
        },
        // format: 'currency',
        rules: [ 'required' ],
    },
    {
        field: 'max_fonasa_uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo FONASA ($)',
        },
        // format: 'currency',
        rules: [ 'required' ],
    },
    {
        field: 'max_health_uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo IPS ($)',
        },
        // format: 'currency',
        rules: [ 'required' ],
    },
    {
        field: 'max_unemployment_insurance_uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Seguro Cesantía ($)',
        },
        // format: 'currency',
        rules: [ 'required' ],
    },
    {
        field: 'imm',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Renta Mínima Imponible',
        },
        format: 'currency',
        rules: [ 'required' ],
    },
    {
        field: 'max_apv_monthly_uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Mensual APV ($)',
        },
        // format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'max_apv_yearly_uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Anual ($)',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
]
